export default __webpack_public_path__ + "video/1_establish_keep.mp4";